import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";

import { type LogView, OpportunityLog } from "@/features/opportunities/OpportunityLog";
import { logSearch } from "@/features/opportunities/search";

export const Route = createFileRoute("/stats/log")({ component: Log, validateSearch: logSearch });

function Log() {
    const { filter = "actionable", page = 1 } = Route.useSearch();
    const navigate = Route.useNavigate();
    const onView = useCallback((view: LogView, replace?: boolean) => navigate({ search: view, replace }), [navigate]);

    return <OpportunityLog view={{ filter, page }} onView={onView} />;
}
